import React from 'react';
import PropTypes from 'prop-types';
import NodeActivityEditor from '../../NodeActivityEditor';
import PrimaryButton from '../../PrimaryButton';
import SecondaryButton from '../../SecondaryButton';
import CommentsIcon from '../../../../public/assets/images/theme-2/icons/asterisk-white.svg';
import { PreviewSection, ButtonWrapper, SubmitPanel } from '../styles';
import {
  EditorHeaderRowLeft,
  HeaderDate,
  HeaderUserName,
  EditorHeaderRowRight,
  ActivityComments,
  BlogPostOptions,
  BlogPostOptionEdit,
} from '../../NodeActivityEditor/styles';

const BlogContentPreview = ({ type, previewText }) => {
  const isPublic = type === 'public_blog';
  const getKey = (post) => `app_student_${post}editor`;

  const headerPanel1 = (
    <>
      <EditorHeaderRowLeft>
        <HeaderDate>{new Date().toLocaleDateString(baseLocale)}&nbsp;</HeaderDate>
        <HeaderUserName>{i18n.__(getKey('first_'))}</HeaderUserName>
      </EditorHeaderRowLeft>
      <EditorHeaderRowRight className={'ir-hide'}>
        <BlogPostOptions>
          <BlogPostOptionEdit disabled={true}>{i18n.__('app_edit')}</BlogPostOptionEdit>
          <BlogPostOptionEdit disabled={true}>{i18n.__('app_remove')}</BlogPostOptionEdit>
        </BlogPostOptions>
        <ActivityComments src={CommentsIcon} />
      </EditorHeaderRowRight>
    </>
  );

  const headerPanel2 = (
    <>
      <EditorHeaderRowLeft>
        {!isPublic && <HeaderDate>{new Date().toLocaleDateString(baseLocale)}&nbsp;</HeaderDate>}
        <HeaderUserName>{i18n.__(getKey(isPublic ? '' : 'second_'))}</HeaderUserName>
      </EditorHeaderRowLeft>
      <EditorHeaderRowRight />
    </>
  );

  const handInButton = <SecondaryButton text={i18n.__('app_handin')} disabled={true} />;

  const buttonPanel = (
    <ButtonWrapper className={'ir-hide'}>
      <PrimaryButton text={i18n.__('app_publish_post')} disabled={true} />
      {isPublic && handInButton}
    </ButtonWrapper>
  );

  return (
    <>
      <PreviewSection>
        <NodeActivityEditor type={type} headerPanel={headerPanel2} buttonPanel={buttonPanel} editorText={previewText} />
        {!isPublic && (
          <NodeActivityEditor
            type={type}
            disabled={true}
            headerPanel={headerPanel1}
            editorText={i18n.__('logbook_preview_text_2')}
          />
        )}
      </PreviewSection>
      {!isPublic && <SubmitPanel className={'ir-hide'}>{handInButton}</SubmitPanel>}
    </>
  );
};

export default BlogContentPreview;

BlogContentPreview.propTypes = {
  type: PropTypes.string.isRequired,
  previewText: PropTypes.string.isRequired,
};
